import { valueTypeNames } from "../../util/valueTypeNames"
import SmallHeadingComponent from "../SmallHeadingComponent"
import Card from "../Card"
import { useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardBaselinePatientData,
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType
} from "../../redux/ProfessionalDashboard"
import AggregatedDataView from "./chart/AggregatedDataView"
import notNull from "../../util/notNull"
import { useEffect, useState } from "react"
import {
    GetPatientDataCurrentResponsePayload,
    GetPatientsOfProfessionalResponsePayload,
    ValueType
} from "pokal_api"
import { ArrayElement } from "../../types/ArrayElement"
import {
    hidePatientDetailViewDataBaseline,
    mockPatientUsed,
    mockPhqValueTypeUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import mockPatient from "../../onboarding/mock/mockPatient"
import {
    MOCK_PHQ_BASELINE_DATA,
    MOCK_SLEEP_BASELINE_DATA
} from "../../onboarding/mock/mockPatientData"
import ValueTypeDocumentation from "../../documentation/ValueTypeDocumentation"
import DocumentationComponent from "../DocumentationComponent"
import { BASELINE_DATA_DOC } from "../../documentation/Documentation"

function BaselineDataView() {
    const fetchedSelectedPatient = useAppSelector(
        selectDashboardSelectedPatient
    )
    const fetchedSelectedValueType = useAppSelector(
        selectDashboardSelectedValueType
    )
    const fetcheData = useAppSelector(selectDashboardBaselinePatientData)

    const [selectedValueType, setSelectedValueType] =
        useState<ValueType | null>(null)
    const [data, setData] =
        useState<GetPatientDataCurrentResponsePayload | null>(null)
    const [selectedPatient, setSelectedPatient] =
        useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(
            null
        )

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setSelectedPatient(mockPatient()[0])
            if (mockPhqValueTypeUsed(running, step)) {
                setData(MOCK_PHQ_BASELINE_DATA)
                setSelectedValueType(ValueType.PHQUESTIONNAIRE)
            }
            if (mockSleepValueTypeUsed(running, step)) {
                setData(MOCK_SLEEP_BASELINE_DATA)
                setSelectedValueType(ValueType.SLEEP_DURATION)
            }
        } else {
            setData(fetcheData)
            setSelectedValueType(fetchedSelectedValueType)
            setSelectedPatient(fetchedSelectedPatient)
        }
    }, [fetcheData, fetchedSelectedValueType, running, step])

    return (
        <>
            {notNull(data) &&
                notNull(selectedPatient) &&
                notNull(selectedValueType) && (
                    <Card
                        blur={hidePatientDetailViewDataBaseline(running, step)}
                        width={"100%"}>
                        <div className={"w-full flex flex-col space-y-4"}>
                            <SmallHeadingComponent>
                                Baseline Patient:innen-Daten
                            </SmallHeadingComponent>
                            <div>
                                <DocumentationComponent
                                    documentation={BASELINE_DATA_DOC}>
                                    Langzeit-Daten
                                </DocumentationComponent>
                                (d.h. Daten der letzten 90 Tage) von Patient:in{" "}
                                {selectedPatient.firstName}{" "}
                                {selectedPatient.lastName} zur{" "}
                                <DocumentationComponent
                                    documentation={ValueTypeDocumentation(
                                        selectedValueType
                                    )}>
                                    {`Datenkategorie ${valueTypeNames[selectedValueType]}`}
                                </DocumentationComponent>
                            </div>
                            <>
                                <AggregatedDataView dataType={"baseline"} />
                            </>
                        </div>
                    </Card>
                )}
        </>
    )
}

export default BaselineDataView
